var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unicom-linha',{staticClass:"linha-embaixo"},[_c('unicom-coluna',{class:_vm.espacamentoMobile,attrs:{"sm":"2"}},[_c('div',{attrs:{"align":"right"}},[_vm._v("Farmácia")])]),_c('unicom-coluna',{class:_vm.espacamentoMobile,attrs:{"sm":"1"}},[_c('unicom-switch',{attrs:{"value":_vm.clickSwitch},on:{"input":_vm.toggleSwitch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }